/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { SearchClearanceCaseResponseJson } from './search-clearance-case-response-json';
import { ClearanceCaseListResult } from '../results/clearance-case-list-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { ClearanceCaseDto } from '../models/clearance-case-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
import orderBy from 'lodash-es/orderBy';
//</custom-head>

export class SearchClearanceCaseResponse extends ResponseWithErrorGeneric<SearchClearanceCaseResponseJson, ClearanceCaseListResult> implements IResponseWithErrorGeneric<ClearanceCaseListResult> {
  public clearanceCases: ClearanceCaseDto[];

  //<custom-body>
  constructor(response: HttpResponse<SearchClearanceCaseResponse>) {
    super(response, ClearanceCaseListResult.Error);

    if (this.result !== ClearanceCaseListResult.Success) {
        return;
    }

    this.clearanceCases = orderBy(this.body.clearanceCases ? this.body.clearanceCases.map(c => new ClearanceCaseDto(c, null)) : [], ['desc']);
  }
  //</custom-body>
}
